"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
var _index = require("../../styles/index.js");
var _index2 = require("../TypeList/index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* Show up to 5.5 items, then resort to scrolling the rest.
 * We show a "half" item so that it is obvious to the user that there is more below the fold.
 * 32px (item height) * 5.5 + 1px (border height) = 177px
 * */

var focusStyles = function focusStyles($isUsingKeyboard) {
  return (0, _styledComponents.css)(["outline:none;border:", " solid ", ";", ""], (0, _index.cssBorderWidth)('hairline', '1px'), (0, _index.cssColorValue)(_index.semanticColors.essentialBase), $isUsingKeyboard && (0, _styledComponents.css)(["border:", "px solid ", ";"], _index.focusBorderWidth, (0, _index.cssColorValue)(_index.semanticColors.essentialBase)));
};
var List = exports.List = (0, _styledComponents["default"])(_index2.TypeList).attrs({
  condensedAll: true,
  listStyleReset: true
}).withConfig({
  displayName: "List",
  componentId: "sc-mygaxj-0"
})(["", ";display:block;pointer-events:all;width:100%;max-block-size:calc((", " * 5.5) + 1px);overflow:auto;padding-block-start:0;padding-inline-end:0;&:focus{", ";}", ";"], (0, _index.overlay)({
  maxWidth: 'none'
}), (0, _index.cssControlSize)('smaller', '32px'), function (props) {
  return !props.$useBrowserDefaultFocusStyle && focusStyles(props.$isUsingKeyboard);
}, function (props) {
  return props.$isFocus && !props.$useBrowserDefaultFocusStyle && focusStyles(props.$isUsingKeyboard);
});